import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import GreetingText from '../GreetingText/GreetingText';
import s from './Card.scss';
import ImageUpload from '../ImageUpload/ImageUpload';

const Card = ({
  greetingImage,
  greetingText,
  setGreetingText,
  messages,
  formatMessage,
  hasError,
  onUploadImage,
}) => {
  const ref = useRef(null);

  const handleClick = e => {
    e.preventDefault();
    e.stopPropagation();
    ref.current.click();
  };

  return (
    <div>
      <div className={s.preview}>
        <div
          className={s.preview__inner}
          style={{ backgroundImage: `url(${greetingImage})` }}
          role="button"
          tabIndex={0}
          onClick={handleClick}
          onKeyPress={handleClick}
        />{' '}
        <ImageUpload
          ref={ref}
          type="file"
          accept="image/*"
          name="userImageUpload"
          className="visually-hidden"
          onChange={(_, files) => onUploadImage(files)}
        />
      </div>
      <GreetingText
        greetingText={greetingText}
        setGreetingText={setGreetingText}
        formatMessage={formatMessage}
        messages={messages}
        hasError={hasError}
      />
      {hasError && (
        <div className={s.error}>
          {formatMessage({ ...messages.unsupportedCharacter })}
        </div>
      )}
    </div>
  );
};
Card.propTypes = {
  greetingImage: PropTypes.string.isRequired,
  greetingText: PropTypes.string,
  setGreetingText: PropTypes.func.isRequired,
  messages: PropTypes.shape().isRequired,
  formatMessage: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  onUploadImage: PropTypes.func.isRequired,
};

Card.defaultProps = {
  greetingText: '',
  hasError: false,
};

export default withStyles(s)(Card);
